import { render, staticRenderFns } from "./AdminTreinamento.vue?vue&type=template&id=24afafc3&"
import script from "./AdminTreinamento.vue?vue&type=script&lang=js&"
export * from "./AdminTreinamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports